import { useContext, useState } from 'react'

import { Box, Icon } from '@fairfashion/design-system'
import { Position } from 'reactflow'

import { SegmentsDataContext } from '../../../../contexts/segments'
import { IItemTraceability } from '../../../../sdk/traceability/traceability.types'
import { docMask } from '../../../../utilities/masks/brasilianDocuments'
import { VirtualItemDetailsModal } from '../VirtualItemDetailsModal/virtual-item-details-modal.comp'

import * as Styles from './virtual-item-node.styles'

export function VirtualItemNode({
  data,
  sourcePosition,
}: {
  data: IItemTraceability
  sourcePosition?: any
}) {
  const [openDetails, setOpenDetails] = useState(false)

  const { segments } = useContext(SegmentsDataContext)

  const segment = segments.find((item) => item.name === data.provider?.segment)

  const direction =
    sourcePosition === 'right' || sourcePosition === 'left' ? 'LR' : 'TB'

  return (
    <>
      <Styles.CustomHandle
        type="target"
        position={direction === 'LR' ? Position.Left : Position.Top}
      />
      <Styles.Node onClick={() => setOpenDetails(true)}>
        <Box width="100%" flex={1} direction="column" gap={2}>
          <Box width="100%" flex={1} justifyContent="space-between">
            <Styles.SegmentText color={segment?.color ?? 'transparent'}>
              <span></span>
              {segment?.translate}
            </Styles.SegmentText>
          </Box>

          <Box flex={1} width="100%" direction="column">
            <Styles.SmallText>{data.provider?.name}</Styles.SmallText>
            <Styles.SmallText color="grey_3">
              {docMask(data.provider?.taxId ?? '')}
            </Styles.SmallText>
          </Box>
        </Box>

        <Box width="100%" justifyContent="flex-end">
          <Styles.VirtualTag>
            <Icon name="information" size={16} color="purple" />
            Declaração
          </Styles.VirtualTag>
        </Box>
      </Styles.Node>

      <Styles.CustomHandle
        type="source"
        position={direction === 'LR' ? Position.Right : Position.Bottom}
      />

      <VirtualItemDetailsModal
        item={data}
        open={openDetails}
        onClose={() => setOpenDetails(false)}
      />
    </>
  )
}
